import React from 'react';
// import { useHistory } from 'react-router-dom';
import Table from '../components/Table/Table';
import usePpsis from '../features/PpsiContainer/hooks/usePpsis';
// import { ppsiInProgressRoute } from '../routes';
import { EnrichmentData, States } from '../features/PpsiContainer/constants';
import useViewVisited from '../features/app/hooks/useViewVisted';
import ppsiColumns from '../features/PpsiContainer/ui/columns';
import { toJS } from '../utils/immutableUtils';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import ProgressFullscreen from '../components/common/ProgressFullscreen';

const Columns = ppsiColumns(EnrichmentData.IN_PROGRESS);

const PpsiDraftListView = () => {
  // const history = useHistory();
  const [isFetching, ppsisRaw] = usePpsis({ status: States.DRAFT });
  const { isViewVisited } = useViewVisited(View.PpsiListDraft.name, isFetching);
  const isFetched = isViewVisited ? true : !isFetching;
  const ppsis = toJS(ppsisRaw, []);

  // const editPpsi = ppsi => {
  //   history.push(ppsiInProgressRoute(ppsi.id));
  // };

  if (isFetching) {
    return <ProgressFullscreen open />;
  }

  View.PpsiListDraft.visit();

  return (
    <PaperContainer>
      <Table
        title="ppsi.draftListTableTitle"
        data={ppsis}
        columns={[
          Columns.IfoodID,
          Columns.PresentationName,
          Columns.PiaNumber,
          Columns.LifeCycleStatus,
          // Columns.RangeCategory,
          Columns.ModifyDate,
          Columns.ModifiedBy,
          Columns.Updates
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        //  onRowClick={editPpsi}
      />
    </PaperContainer>
  );
};

export default PpsiDraftListView;
